export interface ParsedEksTeam {
  teamKey: string;
  role: 'lead' | 'dev' | 'all';
  isPlatform: boolean;
}

/**
 * Parses a Backstage group ref to determine if it is a valid EKS team group ref.
 * Supports lead, dev, all, and platform roles consistently.
 * Also supports validated hyphenated team keys (e.g. eks-team-quantum-ai-lead).
 *
 * Accepted format:
 *   [group:default/]eks-team-{teamKey}-{role}
 *   where:
 *     - teamKey is lowercase letters, digits, and hyphens (e.g. 'quantum-ai', 'plat')
 *     - role is 'lead', 'dev', or 'all'
 *
 * @param ref The group reference string (e.g., 'group:default/eks-team-foo-bar-lead').
 * @returns The ParsedEksTeam object if the ref matches the format, otherwise null.
 */
export function parseEksTeam(ref: string): ParsedEksTeam | null {
  if (!ref) return null;
  const parts = ref.split('/');
  const name = parts[parts.length - 1].toLowerCase();

  const match = name.match(/^eks-team-([a-z0-9-]+)-(lead|dev|all)$/);
  if (!match) return null;

  const teamKey = match[1];
  const role = match[2] as 'lead' | 'dev' | 'all';

  return {
    teamKey,
    role,
    isPlatform: teamKey === 'plat',
  };
}
